import React from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import { UserWeeklyCapacity } from "~/components/Users/UserWeeklyCapacity";
import { getUserWorkweekById } from "~/store/selectors/selector.weeklyWorkerCapacity";

const WorkAvailability = ({ className, id }) => {
  const userWorkWeekData = useSelector((state) => getUserWorkweekById(state, id));
  return (
    <div className={classnames(`work_availability_wrapper`, className)}>
      <UserWeeklyCapacity workWeekData={userWorkWeekData} />
    </div>
  );
};

WorkAvailability.propTypes = {
  id: PropTypes.number,
  className: PropTypes.string,
};

WorkAvailability.defaultProps = {
  className: ``,
};

WorkAvailability.displayName = `WorkAvailability`;

export default WorkAvailability;
